module.exports = __webpack_public_path__ + "static/maps-bce4fb6117ad5dfdade2bb0701d87818.png";